export default "__VITE_ASSET__wiKVM$Se__"